import React from 'react'
import MyNavbar from '../../../components/user/general/mynavbar/MyNavbar';
import HeroSection from '../../../subscreens/users/Home/herosection/HeroSection';
import Repair from '../../../subscreens/users/Home/repair/Repair';
import BeneFits from '../../../subscreens/users/Home/benefits/BeneFits';
import Testimonials from '../../../subscreens/users/Home/testimonials/Testimonials';
import Footer from '../../../components/user/general/footer/Footer';
import HowDoesItWork from '../../../subscreens/users/Home/howdoesitwork/HowDoesItWork';
import CategorySection from '../../../subscreens/users/Home/categorysection/CategorySection';
import Counter from './../../../components/user/general/counter/Counter'
import VendorProgram from '../../../subscreens/users/Home/vendorprogram/Vendorprogram';
import BlogSection from '../../../subscreens/users/Home/blogs/Blogs';
import Banner from '../../../subscreens/users/Home/banner/Banner';
import Mechanic from '../../../screens/user/maintain/subfolder/mechanic/Mechanic.js'

const Home = () => {
  return (
    <>
      < MyNavbar />
      < HeroSection />
      <CategorySection />
      <Mechanic />
      < Repair />
       < BeneFits />
      <VendorProgram />
      <br/> <br/> 
      <Counter />
      <BlogSection />
      <Banner />
      < Testimonials />
      <HowDoesItWork />
      < Footer/>
    </>


  );

}
export default Home;